export default {
    title: 'light',
    background: {
        primary: '#F2F2F2',
        secundary: '#FFFFFF',
    },
    'text-colors': {
        primary: '#848484',
        secundary: '#111517',
    },
};
